import { useEffect } from "react";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";

// Simple redirect component that redirects to /welcome
export default function WelcomeDialog() {
  const router = useRouter();

  useEffect(() => {
    router.push("/welcome");
  }, [router]);

  return null;
}
